import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronRight, FaThumbsUp,FaSearch, FaChevronLeft } from 'react-icons/fa';
import DonationModel from './DonationModel';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt,FaClock } from 'react-icons/fa';


const Blog = () => {
  // Slider Data for the Sidebar
  const sliderData = [
    { id: 1, title: 'POOR PEOPLE NEED HELP', desc: 'Duis convallis turpis', raised: '$34,000', goal: '$50,489' },
    { id: 2, title: 'HELP HOMELESS CHILDREN', desc: 'Mauris vitae erat', raised: '$12,500', goal: '$20,000' },
    { id: 3, title: 'EMERGENCY FOOD FUND', desc: 'Donec sit amet nisl', raised: '$45,000', goal: '$60,000' },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-play logic for slider
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide]);

  const nextSlide = () => setCurrentSlide((prev) => (prev === sliderData.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentSlide((prev) => (prev === 0 ? sliderData.length - 1 : prev - 1));

  const categories = ['Homeless', 'Children', 'Health Care', 'Food Crisis', 'Environment', 'Other Fund'];
  const helpOptions = ['Become Volunteer', 'Media', 'Donation Send', 'Helping Hand', 'Self Gift', 'Bank Transfer'];
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [errors, setErrors] = useState({});
  
  const validate = () => {
      let tempErrors = {};
      if (!formData.name.trim()) tempErrors.name = "Name is required";
      if (!formData.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) tempErrors.email = "Invalid email format";
      if (!formData.subject) tempErrors.subject = "Subject is required";
      if (formData.message.length < 10) tempErrors.message = "Message must be at least 10 characters";
      setErrors(tempErrors);
      return Object.keys(tempErrors).length === 0;
    };
    const handleSubmit = (e) => {
      e.preventDefault();
      if (validate()) {
        setIsSubmitting(true);
        setTimeout(() => {
          setIsSubmitting(false);
          setSuccessMsg("Thank you! Your message has been sent successfully.");
          setFormData({ name: '', email: '', subject: '', message: '' });
          setTimeout(() => setSuccessMsg(''), 5000);
        }, 2000);
      }
    };

    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: '' });
    };

    const blogPosts = [
    { id: 1, title: "To a Billion People Around the World", tag: "Homeless", img: "/blog1.jpg" },
    { id: 2, title: "I Try to Give to the Poor People", tag: "Donate", img: "/blog2.jpg" },
    { id: 3, title: "There are Two Types of Poor People", tag: "Donate", img: "/blog3.jpg" },
  ];
  const recentPosts = [
    { id: 1, day: "20", month: "December 2016", title: "Build Playground Kids Change", img: "/blog1.jpg" },
    { id: 2, day: "15", month: "December 2016", title: "Build Playground Kids Change", img: "/blog2.jpg" },
    { id: 3, day: "29", month: "December 2016", title: "Build Playground Kids Change", img: "/blog3.jpg" },
  ];
  const description = "To a billion people around the world surviving on just a dollar a day, the question of what to eat tonight To a billion people around the world surviving on just a dollar a day, the question of what to eat tonight......";
  return (
    <div className="min-h-screen bg-white font-sans">
        {/* 1. HERO SECTION */}
        <section className="relative h-[45vh] flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/gallery.jpg')` }}>
            <div className="text-center text-white">
            <motion.h1 
                initial={{ y: 20, opacity: 0 }} 
                animate={{ y: 0, opacity: 1 }} 
                className="text-5xl md:text-6xl font-serif font-black uppercase tracking-tight"
            >
                Blog/News
            </motion.h1>
            <div className="h-1.5 w-20 bg-[#f9b50b] mx-auto mt-4"></div>
            <p className="mt-4 uppercase tracking-[0.3em] text-xs font-bold">
                <Link to="/" className="hover:text-[#f9b50b] text-gray-300 transition-colors">Home</Link>
                <span className="mx-2 text-gray-400">/</span>
                <span className="text-white">Blog</span>
            </p>
            </div>
        </section>

      {/* 2. MAIN CONTENT AREA */}
      <section className="py-20 px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          
            {/* LEFT: BLOG POSTS */}
            <div className="lg:col-span-2 space-y-8">
          {blogPosts.map((post) => (
            <div key={post.id} className="flex flex-col md:flex-row bg-[#fcfcfc] border border-gray-100 group">
              {/* Image Container */}
              <div className="relative overflow-hidden md:w-1/3 h-64 md:h-auto">
                <img 
                  src={post.img} 
                  alt={post.title} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
                />
                <Link 
                  to="/BlogDetail"
                  className="absolute bottom-4 right-0 bg-[#f9b50b] text-white px-6 py-2 text-xs font-bold uppercase tracking-widest hover:bg-[#221f1f] transition-colors"
                >
                  {post.tag}
                </Link>
              </div>

              {/* Text Content */}
              <div className="p-8 md:w-2/3">
                <Link to="/BlogDetail">
                  <h3 className="text-xl font-serif font-bold uppercase text-[#221f1f] hover:text-[#f9b50b] transition-colors mb-4 leading-tight">
                    {post.title}
                  </h3>
                </Link>
                <p className="text-gray-500 text-sm leading-relaxed line-clamp-4">
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>

          {/* RIGHT: SIDEBAR */}
          <div className="space-y-12">

            {/* 1. SEARCH BAR */}
          <div className="relative">
            <input 
              type="text" 
              placeholder="Search" 
              className="w-full bg-[#fcfcfc] border border-gray-100 p-4 pr-12 italic text-sm focus:outline-none focus:border-[#f9b50b]"
            />
            <FaSearch className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer hover:text-[#f9b50b]" />
          </div>

          {/* 2. RECENT POSTS */}
          <div className="bg-[#fcfcfc] p-8 border border-gray-100">
            <h4 className="text-lg font-serif font-bold uppercase mb-8 text-[#221f1f] border-l-4 border-[#f9b50b] pl-4">
              Recent Post
            </h4>
            <div className="space-y-6">
              {recentPosts.map((post) => (
                <div key={post.id} className="flex gap-4 group">
                  <div className="w-16 h-16 flex-shrink-0 overflow-hidden">
                    <img src={post.img} alt="Post" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                  </div>
                  <div>
                    <Link to="/BlogDetail">
                      <h5 className="text-sm font-bold text-[#221f1f] group-hover:text-[#f9b50b] transition-colors leading-snug mb-1">
                        {post.title}
                      </h5>
                    </Link>
                    <div className="flex items-center gap-2">
                      <span className="text-2xl font-serif font-bold text-gray-400">{post.day}</span>
                      <span className="text-[10px] uppercase text-gray-400 leading-none">{post.month}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
            
            {/* INTERACTIVE DONATION SLIDER */}
            <div className="relative group overflow-hidden">
              <img src="/events2.jpg" alt="Cause" className="w-full h-[450px] object-cover" />
              
              {/* Overlay Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-12 px-6">
                
                {/* Right/Left Navigation Buttons */}
                <div className="absolute top-1/2 w-full flex justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button onClick={prevSlide} className="bg-[#f9b50b] hover:bg-[#221f1f] text-white p-3 transition-colors">
                    <FaChevronLeft size={14} />
                  </button>
                  <button onClick={nextSlide} className="bg-[#f9b50b] hover:bg-[#221f1f] text-white p-3 transition-colors">
                    <FaChevronRight size={14} />
                  </button>
                </div>

                {/* Sliding Box */}
                <div className="bg-[#221f1f]/90 w-full p-8 text-center text-white">
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={currentSlide}
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -20 }}
                      transition={{ duration: 0.4 }}
                    >
                      <h4 className="font-serif font-bold text-lg uppercase tracking-wider">{sliderData[currentSlide].title}</h4>
                      <p className="italic text-gray-400 text-sm mt-2 mb-6">{sliderData[currentSlide].desc}</p>
                      
                      <div className="mb-6">
                         <span className="text-[#f9b50b] text-2xl font-bold">{sliderData[currentSlide].raised}</span>
                         <span className="text-xs text-gray-300 ml-2 uppercase">Need {sliderData[currentSlide].goal}</span>
                      </div>

                      <button onClick={() => setIsModelOpen(true)} className="border border-[#f9b50b] text-[#f9b50b] font-bold uppercase py-2 px-8 text-xs tracking-widest hover:bg-white hover:text-[#221f1f] transition-all">
                        Donate 
                        </button>
                    </motion.div>
                  </AnimatePresence>
                </div>
              </div>
              <DonationModel 
            isOpen={isModelOpen} 
            onClose={() => setIsModelOpen(false)} 
            causeTitle={sliderData[currentSlide].title} 
              />
            </div>

            {/* Blog CATEGORIES */}
            <div className="bg-[#fcfcfc] p-8 border border-gray-100">
              <h4 className="text-lg font-serif font-bold uppercase mb-6 text-[#221f1f]">Blog Categories</h4>
              <ul className="space-y-4">
                {categories.map((cat) => (
                  <li key={cat}>
                    <button 
                      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                      className="flex items-center gap-3 text-sm text-gray-500 hover:text-[#f9b50b] transition-colors group w-full text-left"
                    >
                      <FaThumbsUp className="text-xs text-gray-300 group-hover:text-[#f9b50b]" />
                      {cat}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* HOW YOU WILL HELP US SECTION */}
              <div className="relative overflow-hidden group">
                {/* Image with brightness and hover zoom effect */}
                <img 
                  src="/events1.jpg" 
                  alt="Help Us" 
                  className="w-full h-[450px] object-cover brightness-50 group-hover:scale-105 transition-transform duration-700" 
                />
                
                <div className="absolute inset-0 p-10 flex flex-col justify-center">
                  {/* Heading with Yellow accent on 'How' */}
                  <h4 className="text-4xl font-serif font-bold text-white mb-2 leading-tight">
                    <span className="text-[#f9b50b]">How</span> <br /> You will help us
                  </h4>
                  
                  {/* Yellow horizontal bar */}
                  <div className="h-1 w-12 bg-[#f9b50b] my-6"></div>
                  
                  {/* Interactive List */}
                  <ul className="space-y-4">
                    {helpOptions.map((option) => (
                      <li key={option}>
                        <button 
                          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                          className="flex items-center gap-2 text-white text-sm font-medium hover:text-[#f9b50b] transition-colors w-full text-left"
                        >
                          <FaChevronRight className="text-[10px] text-[#f9b50b]" />
                          {option}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            
          </div>
        </div>
        
      </section>
      
      {/* SUBSCRIBE NOW SECTION */}
      <section className="bg-[#1a1818] py-20 px-6 border-y border-gray-800">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-white text-4xl font-serif font-bold uppercase tracking-wider mb-4">
            Subscribe <span className="text-[#f9b50b]">Now</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-base mb-10 font-light max-w-2xl mx-auto leading-relaxed">
            Receive our weekly newsletter with educational materials, upcoming interfaith events, 
            and stories of unity from our community.
          </p>
          <form className="flex flex-col md:flex-row items-center justify-center gap-0 max-w-2xl mx-auto shadow-2xl">
            <input
              type="email"
              placeholder="Your Email Address"
              required
              className="w-full md:w-2/3 py-4 px-6 focus:outline-none bg-white text-[#1a1818] text-sm"
            />
            <button
              type="submit"
              className="w-full md:w-1/3 py-4 px-6 bg-[#f9b50b] border-2 border-[#f9b50b] text-[#1a1818] font-black uppercase tracking-widest hover:bg-transparent hover:text-[#f9b50b] transition-all duration-300 text-xs"
            >
              Subscribe
            </button>
          </form>
          <p className="text-[10px] text-gray-600 uppercase tracking-[0.2em] mt-6">
            Unity in Diversity • Illinois Interfaith
          </p>
        </div>
      </section>

      
            {/* 2. GET IN TOUCH HEADER */}
                  <section className="pt-20 pb-10 text-center">
                    <h2 className="text-5xl font-serif font-bold uppercase text-[#221f1f] mb-2">Get In Touch</h2>
                    <p className="text-gray-400 text-sm uppercase tracking-widest font-bold">Contact Us</p>
                    <div className="h-[2px] w-16 bg-[#f9b50b] mx-auto mt-6"></div>
                  </section>
            
                  {/* 3. MAIN CONTACT CONTENT */}
                  <section className="pb-24 px-6 max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
                      
                      {/* LEFT COLUMN: CONTACT INFO */}
                      <div className="lg:col-span-1 space-y-12">
                        <div className="flex gap-5">
                          <FaMapMarkerAlt className="text-[#f9b50b] text-2xl mt-1" />
                          <div >
                            <h4 className="font-serif font-bold text-xl uppercase mb-3">Office Address</h4>
                            <a 
                              href="https://www.google.com/maps/search/?api=1&query=1645+W+Irving+Park+Rd+Suite+100+Hanover+Park+IL+60133" 
                              target="_blank" 
                              rel="noopener noreferrer" 
                              className="text-gray-500 text-sm not-italic leading-relaxed hover:text-[#f9b50b] transition-colors"
                            >
                              1645 W Irving Park Rd, Suite # 100 <br />
                              Hanover Park, IL, United States, Illinois 60133
                            </a>
                          </div>
                        </div>
            
                        <div className="flex gap-5">
                          <FaPhoneAlt className="text-[#f9b50b] text-2xl mt-1" />
                          <div>
                            <h4 className="font-serif font-bold text-xl uppercase mb-3">Phone</h4>
                            <a href="tel:18477377065" className="text-gray-500 text-sm hover:text-[#f9b50b] transition-colors">+1 (847) 737-7065</a>
                          </div>
                        </div>
            
                        <div className="flex gap-5">
                          <FaClock className="text-[#f9b50b] text-2xl mt-1" />
                          <div>
                            <h4 className="font-serif font-bold text-xl uppercase mb-3">Working Hours</h4>
                            <p className="text-gray-500 text-sm leading-relaxed">
                              Monday – Saturday: Always Open <br />
                              (Community inquiries welcomed anytime) <br />If your template requires fixed hours, use: <br />Monday – Friday: 9:00 AM – 5:00 PM <br />Saturday & Sunday: By Appointment
                            </p>
                          </div>
                        </div>
            
                        <div className="flex gap-5">
                          <FaEnvelope className="text-[#f9b50b] text-2xl mt-1" />
                          <div>
                            <h4 className="font-serif font-bold text-xl uppercase mb-3">Email</h4>
                            <a href="mailto:info@ilinterfaith.org" className="text-gray-500 text-sm hover:text-[#f9b50b] transition-colors">info@ilinterfaith.org</a>
                          </div>
                        </div>
                      </div>
            
                      {/* RIGHT COLUMN: CONTACT FORM */}
                      <div className="lg:col-span-2">
                        <h3 className="text-2xl font-serif font-bold uppercase mb-8">Send Us Email</h3>
                        <form onSubmit={handleSubmit} className="space-y-4">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                              <input 
                                type="text" name="name" value={formData.name} onChange={handleChange}
                                placeholder="Enter your full name" 
                                className={`w-full p-4 bg-gray-50 border ${errors.name ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                              />
                              {errors.name && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.name}</p>}
                            </div>
                            <div className="space-y-1">
                              <input 
                                type="email" name="email" value={formData.email} onChange={handleChange}
                                placeholder="Enter your email" 
                                className={`w-full p-4 bg-gray-50 border ${errors.email ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                              />
                              {errors.email && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.email}</p>}
                            </div>
                          </div>
                          
                          <div className="space-y-1">
                            <input 
                              type="text" name="subject" value={formData.subject} onChange={handleChange}
                              placeholder="Subject" 
                              className={`w-full p-4 bg-gray-50 border ${errors.subject ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                            />
                            {errors.subject && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.subject}</p>}
                          </div>
            
                          <div className="space-y-1">
                            <textarea 
                              name="message" rows="8" value={formData.message} onChange={handleChange}
                              placeholder="Write your message" 
                              className={`w-full p-4 bg-gray-50 border ${errors.message ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                            ></textarea>
                            {errors.message && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.message}</p>}
                          </div>
            
                          <button 
                            disabled={isSubmitting}
                            className="bg-[#221f1f] text-white font-bold uppercase tracking-widest px-10 py-4 hover:bg-[#221f1f] transition-all disabled:bg-gray-400 mt-4 text-xs shadow-lg"
                          >
                            {isSubmitting ? "Sending..." : "Send Message"}
                          </button>
            
                          {successMsg && (
                            <motion.div 
                              initial={{ opacity: 0, y: 10 }} 
                              animate={{ opacity: 1, y: 0 }} 
                              className="mt-6 p-4 bg-green-50 border border-green-200"
                            >
                              <p className="text-green-700 font-bold text-center text-sm uppercase tracking-tight">
                                {successMsg}
                              </p>
                            </motion.div>
                          )}
                        </form>
                      </div>
                      </div>
                  </section>          
    </div>
  );
};

export default Blog;